import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import navigateParams from '../../../../../utils/navigation/navigateParams';

const FeedbackContactsValidate: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();
    const err = state?.err;
    const stateFeedback = state?.stateFeedback;
    const [params] = useSearchParams();
    const flow = params.get('flow')!;
    const size = useWindowSize();

    const sendToNative = (url: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        if (navigateParams(type, url, queryParams)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <>
            <div
                className='feedbackContactsValidate-page'
                style={{
                    background:
                        stateFeedback === 'SUCCESS'
                            ? size.width < 1024 || size.height < 550
                                ? skinVars.colors.backgroundBrand
                                : ''
                            : skinVars.colors.background,
                }}
            >
                {stateFeedback === 'SUCCESS' ? (
                    <SuccessFeedbackScreen
                        title={t('contactVerificationSuccessTitle')}
                        description={
                            flow === 'mobile'
                                ? t('descriptionFeedbackSuccesOtpMobile')
                                : t('descriptionFeedbackSuccesOtpEmail')
                        }
                        primaryButton={
                            <ButtonPrimary
                                onPress={() => {
                                    if (isWebviewAndroid || isWebviewIOS) {
                                        sendToNative('/profile');
                                    } else {
                                        sendToNative('/profile/personal-data');
                                    }
                                }}
                            >
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                    ></SuccessFeedbackScreen>
                ) : (
                    <ErrorFeedbackScreen
                        title={err.title}
                        description={err.localizedDescription}
                        errorReference={'Código de error: ' + `${err.id}`}
                        primaryButton={
                            <ButtonPrimary
                                onPress={() => {
                                    if (isWebviewAndroid || isWebviewIOS) {
                                        sendToNative('/profile');
                                    } else {
                                        sendToNative('/profile/personal-data');
                                    }
                                }}
                            >
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                    ></ErrorFeedbackScreen>
                )}
            </div>
        </>
    );
};

export default FeedbackContactsValidate;
